// AuthHead — la tête des écrans d'ENTRÉE (connexion, mot de passe oublié) : marque, surface, titre.
//
// ⚠️ POURQUOI UN COMPOSANT POUR TROIS LIGNES (règle de 2) : ce bloc vivait en DEUX copies identiques
// (`Login.tsx`, `Reset.tsx`). L'arbitrage de marque devait réécrire la même chose aux deux endroits, et
// c'est exactement ainsi qu'une surface finit par se présenter sous deux noms selon la porte par laquelle
// on entre. Une marque n'a qu'une source, comme un jeton.
//
// ⚠️ MÉTRIQUES RELEVÉES SUR LA MAQUETTE (`apps/edi/design/Edi Admin.dc.html`) : monogramme 40×41, et
// 12 px jusqu'au libellé — la maquette les écrit en deux morceaux (gap 8 du bloc + 4 px sous l'image),
// ici en UN seul, parce que la primitive de marque ne prend pas de style. Même espacement rendu ;
// l'ancien rendu posait déjà 12, donc rien ne bouge de ce côté.
import { SliderzMark } from '@orgazone/ui-web';

/**
 * ⚠️ LA MARQUE EST CELLE DU PRODUIT (arbitrage utilisateur) : l'EDI alimente les catalogues du
 * commerçant, il appartient donc à la chaîne Sliderz — la Console, le store privé et l'IdP restent
 * signés Orgazone, qui sont les surfaces de l'ÉDITEUR. La décision vaut pour le rail ET pour ici :
 * entrer par la connexion et lire un autre nom que celui du rail serait le même défaut, vu deux fois.
 */
export function AuthHead({ title }: { title: string }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 12, marginBottom: 20 }}>
      <SliderzMark size={40} height={41} />
      <div style={{ textAlign: 'center' }}>
        <div style={{ fontSize: 'var(--t-sub)', fontWeight: 700, letterSpacing: '.08em', textTransform: 'uppercase', color: '#16a585' }}>Sliderz EDI</div>
        {/* Interligne serré relevé sur la maquette (`-0.01em`) — un titre de 20 px sans lui respire un peu plus large. */}
        <div style={{ fontSize: 20, fontWeight: 800, color: '#131618', letterSpacing: '-0.01em' }}>{title}</div>
      </div>
    </div>
  );
}
